// @ts-nocheck
import React from "react";
import { translate } from "../../../base/i18n/functions";
import { connect } from "../../../base/redux/functions";
import Dialog from "../../../base/ui/components/web/Dialog";
import AbstractGrantModeratorDialog, { abstractMapStateToProps, } from "../AbstractGrantModeratorDialog";
// CUSTOM
import moment from "moment";
import { setConfirmationModalProps } from "../../../customise/redux/tool-webjam-v3/actions";
import { dispatch, getBaseConfig, getStore } from "../../../customise/Utils";
import { FEATURE_CUSTOM_REDUX } from "../../../customise/constant";
import { socketEmit } from "../../../../../socket";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ct, localeCalender } from "../../../customise/constant-Utils";
import { CURRENT_ROOM_NAME } from "../../../webjam/constant";
// END
/**
 * Dialog to confirm a grant moderator action.
 */
// CUSTOM
var now = moment();
// END
class GrantModeratorDialog extends AbstractGrantModeratorDialog {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    // CUSTOM
    constructor(props) {
        super(props);
        this.state = {
            moderatorDate: "",
            moderatorDateTiming: {
                access_started: "",
                access_ended: "",
            },
            customDateShow: false,
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeDate = this.handleChangeDate.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.clickOnDatePickerFrom = React.createRef();
        this.clickOnDatePickerTo = React.createRef();
        this.minTime = now.hours(now.hour()).minutes(now.minutes());
    }
    handleChange(e) {
        const { name, value } = e.target;
        this.setState({
            moderatorDate: value,
            moderatorDateTiming: {
                access_started: "",
                access_ended: "",
            },
        });
        if (value == "customDate") {
            this.setState({
                customDateShow: true,
            });
        }
        else {
            this.setState({
                customDateShow: false,
            });
        }
    }
    handleChangeDate(date) {
        let _this = this;
        const { moderatorDateTiming } = this.state;
        let updateObj = {};
        let additionTime = "";
        if (date.access_started) {
            if (new Date(date.access_started).getHours() > 0) {
                if (new Date(date.access_started).getTime() / 1000 <
                    new Date().getTime() / 1000) {
                    dispatch(setConfirmationModalProps({
                        isShow: true,
                        title: ct("Translate.typography.alert"),
                        content: ct("Translate.messages.moderatorStartDateValidation"),
                        showCancelButton: false,
                        cancelBtnName: ct("Translate.buttonTitle.cancelSmall"),
                        successBtnName: ct("Translate.buttonTitle.okSmall"),
                        onSuccess: () => {
                            this.setState({
                                moderatorDateTiming: {
                                    access_started: "",
                                    access_ended: "",
                                },
                            });
                            dispatch(setConfirmationModalProps({ isShow: false }));
                        },
                    }));
                    return false;
                }
                this.clickOnDatePickerTo.current.setOpen(true);
                setTimeout(function () {
                    _this.clickOnDatePickerFrom.current.setOpen(false);
                }, 100);
            }
            date.access_started = date.access_started;
        }
        else if (date.access_ended) {
            if (moderatorDateTiming.access_started &&
                new Date(date.access_ended).getHours() > 0) {
                if (new Date(date.access_ended).getTime() / 1000 <
                    new Date(moderatorDateTiming.access_started).getTime() / 1000) {
                    dispatch(setConfirmationModalProps({
                        isShow: true,
                        title: ct("Translate.typography.alert"),
                        content: ct("Translate.messages.moderatorEndDateValidation"),
                        showCancelButton: false,
                        cancelBtnName: ct("Translate.buttonTitle.cancelSmall"),
                        successBtnName: ct("Translate.buttonTitle.okSmall"),
                        onSuccess: () => {
                            this.setState({
                                moderatorDateTiming: {
                                    ...moderatorDateTiming,
                                    access_ended: "",
                                },
                            });
                            dispatch(setConfirmationModalProps({ isShow: false }));
                        },
                    }));
                    return false;
                }
                setTimeout(function () {
                    _this.clickOnDatePickerTo.current.setOpen(false);
                }, 100);
            }
            date.access_ended = date.access_ended;
        }
        this.setState({
            moderatorDateTiming: {
                ...moderatorDateTiming,
                ...date,
            },
        });
    }
    handleSubmit() {
        const { userLoginData } = getStore(FEATURE_CUSTOM_REDUX);
        let formData = {
            access_started: "",
            access_ended: "",
            roomName: CURRENT_ROOM_NAME,
            role: "moderator",
            jitsi_id: this.props.participantID,
            room_id: userLoginData.room.id || userLoginData.room._id,
            // user_id : userLoginData.user.id
        };
        let willProceed = false;
        const { customDateShow, moderatorDateTiming, moderatorDate } = this.state;
        if (customDateShow && !moderatorDateTiming.access_started) {
            dispatch(setConfirmationModalProps({
                isShow: true,
                title: ct("Translate.typography.alert"),
                content: ct("Translate.messages.moderatorSelectStartDateValidation"),
                showCancelButton: false,
                cancelBtnName: ct("Translate.buttonTitle.cancelSmall"),
                successBtnName: ct("Translate.buttonTitle.okSmall"),
                onSuccess: () => {
                    dispatch(setConfirmationModalProps({ isShow: false }));
                },
            }));
            return false;
        }
        else if (customDateShow && !moderatorDateTiming.access_ended) {
            dispatch(setConfirmationModalProps({
                isShow: true,
                title: ct("Translate.typography.alert"),
                content: ct("Translate.messages.moderatorSelectEndDateValidation"),
                showCancelButton: false,
                cancelBtnName: ct("Translate.buttonTitle.cancelSmall"),
                successBtnName: ct("Translate.buttonTitle.okSmall"),
                onSuccess: () => {
                    dispatch(setConfirmationModalProps({ isShow: false }));
                },
            }));
            return false;
        }
        else if (!moderatorDate) {
            dispatch(setConfirmationModalProps({
                isShow: true,
                title: ct("Translate.typography.alert"),
                content: ct("Translate.messages.moderatorAccessDateValidation"),
                showCancelButton: false,
                cancelBtnName: ct("Translate.buttonTitle.cancelSmall"),
                successBtnName: ct("Translate.buttonTitle.okSmall"),
                onSuccess: () => {
                    dispatch(setConfirmationModalProps({ isShow: false }));
                },
            }));
            return false;
        }
        else {
            if (moderatorDateTiming.access_ended &&
                moderatorDateTiming.access_started) {
                if (new Date(moderatorDateTiming.access_ended).getTime() / 1000 <
                    new Date(moderatorDateTiming.access_started).getTime() / 1000) {
                    dispatch(setConfirmationModalProps({
                        isShow: true,
                        title: ct("Translate.typography.alert"),
                        content: ct("Translate.messages.moderatorEndDateValidation"),
                        showCancelButton: false,
                        cancelBtnName: ct("Translate.buttonTitle.cancelSmall"),
                        successBtnName: ct("Translate.buttonTitle.okSmall"),
                        onSuccess: () => {
                            dispatch(setConfirmationModalProps({ isShow: false }));
                        },
                    }));
                    return false;
                }
            }
            if (moderatorDate == "today") {
                formData.access_started = moment().utc().format("YYYY-MM-DD HH:mm:ss");
                formData.access_ended = moment()
                    .endOf("day")
                    .utc()
                    .format("YYYY-MM-DD HH:mm:ss");
            }
            else if (moderatorDate == "tomorrow") {
                formData.access_started = moment()
                    .add(1, "days")
                    .startOf("day")
                    .utc()
                    .format("YYYY-MM-DD HH:mm:ss");
                formData.access_ended = moment()
                    .add(1, "days")
                    .endOf("day")
                    .utc()
                    .format("YYYY-MM-DD HH:mm:ss");
            }
            else if (moderatorDate == "oneWeek") {
                formData.access_started = moment().utc().format("YYYY-MM-DD HH:mm:ss");
                formData.access_ended = moment()
                    .utc()
                    .add(6, "days")
                    .format("YYYY-MM-DD HH:mm:ss");
            }
            else if (moderatorDate == "customDate") {
                try {
                    formData.access_started = moment(moderatorDateTiming.access_started)
                        .utc()
                        .format("YYYY-MM-DD HH:mm:ss");
                    formData.access_ended = moment(moderatorDateTiming.access_ended)
                        .utc()
                        .format("YYYY-MM-DD HH:mm:ss");
                }
                catch (e) {
                    console.log("errroor ", e);
                }
            }
            socketEmit("moderator_access_update", formData);
            willProceed = true;
        }
        if (willProceed) {
            this._onSubmit();
            return true;
        }
    }
    // render() {
    //     return (
    //         <Dialog
    //             ok = {{ translationKey: 'dialog.Yes' }}
    //             onSubmit = { this._onSubmit }
    //             titleKey = 'dialog.grantModeratorTitle'>
    //             <div>
    //                 { this.props.t('dialog.grantModeratorDialog', { participantName: this.props.participantName }) }
    //             </div>
    //         </Dialog>
    //     );
    // }
    render() {
        const now = moment();
        const { userLoginData } = getStore(FEATURE_CUSTOM_REDUX);
        const { customDateShow, moderatorDateTiming } = this.state;
        return (React.createElement(Dialog, { okKey: "dialog.Yes", onSubmit: (userLoginData.room ||
                userLoginData.isRoomClaimed ||
                userLoginData.isPrivate) &&
                getBaseConfig("willAuthorize") == false
                ? this.handleSubmit
                : this._onSubmit, titleKey: "dialog.grantModeratorTitle", width: userLoginData.room ||
                userLoginData.isRoomClaimed ||
                userLoginData.isPrivate
                ? "large"
                : "medium", testId: userLoginData.room ||
                userLoginData.isRoomClaimed ||
                userLoginData.isPrivate
                ? "grant-mod-dialog"
                : "grant-mod-rights-popup", rtaClassName: "grant-mod-dialog" // CUSTOM
         },
            React.createElement("div", { className: "moderator-modal-wrap" }, getBaseConfig("willAuthorize") == false &&
                (userLoginData.room ||
                    userLoginData.isRoomClaimed ||
                    userLoginData.isPrivate) ? (React.createElement(React.Fragment, null,
                React.createElement("h3", null, this.props.t("dialog.grantModeratorDialog", {
                    participantName: this.props.participantName,
                })),
                React.createElement("div", { className: "container" },
                    React.createElement("div", { className: "row" },
                        React.createElement("div", { className: "col-lg-4 col-12 mb-2 check-wrap" },
                            React.createElement("label", null,
                                React.createElement("input", { type: "radio", name: "moderatorDate", value: "today", onChange: this.handleChange }),
                                React.createElement("span", { className: "checkmark" })),
                            React.createElement("span", { className: "grant-check-text" }, ct("rta-trmc.grantModerator.today"))),
                        React.createElement("div", { className: "col-lg-4 col-12 mb-2 check-wrap" },
                            React.createElement("label", null,
                                React.createElement("input", { type: "radio", name: "moderatorDate", value: "tomorrow", onChange: this.handleChange }),
                                React.createElement("span", { className: "checkmark" })),
                            React.createElement("span", { className: "grant-check-text" }, ct("rta-trmc.grantModerator.tomorrow"))),
                        React.createElement("div", { className: "col-lg-4 col-12 mb-2 check-wrap" },
                            React.createElement("label", null,
                                React.createElement("input", { type: "radio", name: "moderatorDate", value: "oneWeek", onChange: this.handleChange }),
                                React.createElement("span", { className: "checkmark" })),
                            React.createElement("span", { className: "grant-check-text" }, ct("rta-trmc.grantModerator.oneWeek"))),
                        React.createElement("div", { className: "col-lg-12 mb-2 check-wrap" },
                            React.createElement("label", null,
                                React.createElement("input", { type: "radio", name: "moderatorDate", value: "customDate", onChange: this.handleChange }),
                                React.createElement("span", { className: "checkmark" })),
                            React.createElement("span", { className: "grant-check-text" }, ct("rta-trmc.grantModerator.customDate")),
                            customDateShow && (React.createElement(React.Fragment, null,
                                React.createElement("div", { className: "d-flex w-100 justify-content-between mt-2" },
                                    React.createElement("label", null,
                                        React.createElement(DatePicker, { dateFormat: "yyyy-MM-dd HH:mm", onChange: (date) => this.handleChangeDate({ access_started: date }), selected: moderatorDateTiming.access_started, value: moderatorDateTiming.access_started, placeholderText: "From", minDate: new Date(), showTimeSelect: true, ref: this.clickOnDatePickerFrom, locale: localeCalender() })),
                                    React.createElement("label", { style: { marginLeft: "20px" } },
                                        React.createElement(DatePicker, { dateFormat: "yyyy-MM-dd HH:mm", onChange: (date) => this.handleChangeDate({ access_ended: date }), selected: moderatorDateTiming.access_ended, value: moderatorDateTiming.access_ended, placeholderText: "To", minDate: new Date(), showTimeSelect: true, ref: this.clickOnDatePickerTo, locale: localeCalender() })))))))))) : (React.createElement(React.Fragment, null, this.props.t("dialog.grantModeratorDialog", {
                participantName: this.props.participantName,
            }))))));
    }
}
export default translate(connect(abstractMapStateToProps)(GrantModeratorDialog));
